import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Button } from "@mui/material"

import BackIcon from "../../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"
import CustomConditionalActionsTableServer from "../../../components/CustomConditionalActionsTableServerSide"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import CustomFieldsetAccordion from "../../../components/CustomFieldsetAccordion"
import { useState } from "react"
import CustomAutocomplete from "../../../components/CustomAutocomplete"
import { useQuery } from "@tanstack/react-query"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const VendedorPedidosMostradorBuscar = () => {
  const navigate = useNavigate()
  const [expanded, setExpanded] = useState(false)
  const handleToggle = () => {
    setExpanded(!expanded)
  }
  const [filtrosGenerales, setFiltrosGenerales] = useState({
    vendedorCB: null,
  })

  const [refreshCustomMultiRowSelectionRefKey, setRefreshCustomMultiRowSelectionRefKey] = useState(1) // <-- Controla el reinicio del table cada vez que se de click en la busqueda
  // Nuevo estado para forzar recarga completa de datos
  const [forceDataRefresh, setForceDataRefresh] = useState(0)
  const {
    data: dataAllVendedores = [],
    isError: dataErrorAllVendedores,
    isFetching: isFetchingAllVendedores,
    isLoading: isLoadingAllVendedores,
  } = useGetAllVendedores()

  function useGetAllVendedores() {
    return useQuery({
      queryKey: ["VendedoresPedidosMostradrorBuscar"],
      queryFn: async () => {
        const response = await fetchwrapper(`/comisiones/getVendedores`)
        let result = await response.json()
        result = result.data
        return result
      },
      onError: () => {
        console.log("Error fetching data vendedores")
      },
    })
  }

  const handleClickFiltrarBtn = async () => {
    setRefreshCustomMultiRowSelectionRefKey((prev) => prev + 1)
    setForceDataRefresh((prev) => prev + 1)
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Consulta</b>
        </div>
        <CustomBackdrop isLoading={isLoadingAllVendedores || isFetchingAllVendedores} />
        <Box className={StyledRoot}>
          <CustomFieldsetAccordion title="Filtros Generales" expanded={expanded} onToggle={handleToggle}>
            <CustomAutocomplete
              label="Vendedor"
              selectedOption={filtrosGenerales.vendedorCB}
              setSelectedOption={(v) => {
                setFiltrosGenerales((prev) => ({
                  ...prev,
                  vendedorCB: v,
                  vencodigo: v?.vencodigo ?? "",
                  vennombre: v?.vennombre ?? "",
                }))
              }}
              options={dataAllVendedores}
            />
            <Button variant="contained" color="primary" onClick={handleClickFiltrarBtn} style={{ marginTop: "25px" }}>
              Filtrar
            </Button>
          </CustomFieldsetAccordion>

          <CustomConditionalActionsTableServer
            key={`PMCONSULTABUSCAR-${refreshCustomMultiRowSelectionRefKey}-${forceDataRefresh}`}
            endpoint="/VendedorPedidosMostrador/getAllCitasBuscarOpcion"
            endpointJson={{
              externalFilters: {
                vencodigo: filtrosGenerales?.vencodigo,
              },
            }}
            errorMsgFilterSearch="Error en cargar datos"
            queryKeyModal="VendedorPedidosMostradorCitasBuscar"
            perPage={10}
            rowActions={(row) => {
              const record = row.original
              const actions = [
                {
                  label: "Ver",
                  key: "VerAction",
                  icon: <RemoveRedEyeIcon sx={{ color: "#14AFF7" }} />,
                  onClick: (row) => {
                    navigate(`cita`, { state: row.original })
                  },
                },
              ]

              if (record?.hasPermissionToDelete !== 0) {
                actions.push({
                  label: "Eliminar",
                  key: "EliminarAction",
                  icon: <img src={EliminarIcon} alt="Eliminar" width={23} />,
                  onClick: (row) => {
                    navigate(`/home/dashboard/VendedorTemp/eliminar/cita`, { state: row.original })
                  },
                })
              }

              return actions
            }}
            columnsTable={[
              {
                accessorKey: "pednumped",
                header: "ID Cita",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "vennombre",
                header: "Administrador",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "nickname",
                header: "Nickname",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "comentario",
                header: "Comentario",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "pedfecemi",
                header: "Fecha Emisión",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
              },
              {
                accessorKey: "pedfecven",
                header: "Fecha Vencimiento",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default VendedorPedidosMostradorBuscar
